import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">琪琪影院</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/50">
              琪琪影院打造电影大全在线观看，最新电影热门电影一网打尽，科幻电影动作电影高清蓝光画质免费看不缓冲。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#categories" className="no-underline">电影分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/sci-fi" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">科幻电影</Link></li>
              <li><Link to="/category/action" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">动作电影</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">喜剧电影</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-50/50 whitespace-nowrap">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                contact@qiqicinema.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/50 whitespace-nowrap">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/50 whitespace-nowrap">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                北京市朝阳区建国路88号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {new Date().getFullYear()} 琪琪影院 - 电影大全 最新电影 热门电影 高清蓝光免费在线看
          </p>
          <div className="flex items-center gap-4">
            <a href="#wechat" className="text-sm text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">微信公众号</a>
            <a href="#weibo" className="text-sm text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">微博</a>
            <a href="#privacy" className="text-sm text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}